export default {
  useIdToFindResourceList: {
    warning1: 'resource must be an object',
    warning2: 'prefix must be a non-empty string',
    warning3: 'resourceType must be a non-empty string',
    warning4: 'category must be an array',
    warning5: 'categoryId must be numeric format',
  },
  validator: {
    message1: 'The number of files in the zip file must be',
    message2:
      'The file name of the file in the zip must be the same as the file name of the base package',
    message3: 'The number of files in the zip file must be',
    message4: 'The file name in the zip file is incorrect',
    message5: 'The number of files in the zip file must be',
    dragonBones: {
      errors: [
        'The DragonBones file name must end with _ske.json、_tex.json、_tex.png',
        'The DragonBones file name must end with .ani、.json、.png',
        'The DragonBones file name must end with .sk、.png',
      ],
      defaultError: 'The DragonBones file format is incorrect',
    },
    model: {
      message1: 'Your fbx file contains more than 1 mesh.',
      message2:
        'Incorrect file format: the zip contains both fbx file and texture file, pls make sure they are correctly grouped together and keep the same file format as the original file.',
      message3: 'Incorrect file format, pls upload zip format file only.',
      message4:
        'Incorrect file format, please delete other files and only keep the fbx file.',
      message5: 'Please make sure the file size is under 1MB.',
      message6:
        'Incorrect file format: the zip contains both fbx file and texture file, pls make sure they are correctly grouped together and keep the same file format as the original file.',
      tips: {
        modelRequirements: '3D model asset requirement：',
        modelRequirementsTips: [
          'Each fbx file only contains 1 mesh',
          'Keep the same skeleton hierarchy as the original file. Pls download the original file for reference',
        ],
        fileRequirements: 'File upload requirements：',
        fileRequirementsTips: [
          'File format: zip',
          'File size under 1MB',
          'Zip file should contain the same asset type as the original file',
          'If the zip contains both FBX. file and texture file, pls make sure they are correctly grouped together and keep the same file format as the original file',
          "If the original zip file doesn't apply texture file, pls delete other files",
        ],
      },
    },
  },
  categorySearch: {
    searchText: 'Search',
    searchNotmatchTitle: 'No Results',
    searchNotmatchDetail:
      'Sorry, no eligible results were found. It is suggested to change to different search criteria.',
  },
  nav: {
    home: {
      dmaker: 'Customized Playables',
      gmaker: 'Playable Template Tool',
    },
    version: 'Version Management',
    versionEdit: 'Edit Version',
    dcoVersion: 'Dco Version Management',
    dcoVersionEdit: 'DCO Configuration',
    multiVersion: 'Variation Version Management',
    multiVersionEdit: 'Multi-Combination Configuration',
    commonTemplate: 'Template Library',
  },
  languagePacks: {
    warning: 'Not included in the language list',
    warning1: 'There is no default language in the language list',
    warning2: 'Please choose language',
    warning3: 'Please upload file',
    error1: 'Failed to read file',
    error2: 'Upload Failed, please try again.',
    backup: 'Default Language',
    editText: '+Edit',
    addLanguageButton: 'Add Language',
    changeLanguageButton: 'Language to Modify',
    saveLanguageButton: 'Save Language',
    chooseLanguage: 'Language',
    properties: {
      placeholder: 'Please Fill in',
      required: 'The text cannot be empty',
    },
    defaultLanguage: 'Default Language',
    isOpen: 'Open access to add/del language',
    open: 'open',
    close: 'close',
    tip: 'If the languages of the work does not match the language of your device, this default language will be applied.',
    font: 'Font',
    fontColor: 'Font color',
    fontSize: 'Font size',
    borderThickness: 'Borders',
    borderColor: 'Borders color',
    bold: 'Bold',
    alpha: 'Opacity',
    italic: 'Italic',
    enableShadow: 'Enable Shadow',
    shadowColor: 'Shadow Color',
    shadowBlur: 'Shadow Blur',
    shadowOffsetX: 'Shadow OffsetX',
    shadowOffsetY: 'Shadow OffsetY',
    gradient: 'Gradient',
    startColor: 'Start Color',
    endColor: 'End Color',
    enableGlow: 'Enable Glow',
    glowColor: 'Glow Color',
    glowBlur: 'Glow Blur',
    enableDeleteline: 'Enable Deleteline',
    enableUnderline: 'Enable Underline',
    lineHeight: 'Line Height',
    letterSpacing: 'Kerning',
    confirm: 'Confirm',
    cancel: 'Cancel',
    add: 'Add',
    update: 'Update',
    language: 'Language',
    uploadFile: 'Upload File',
    languageSelectorPlaceHolder: 'Please select language',
    only: 'Upload only',
    widthHeightTip: 'Width & Height Restriction',
    dragUploadTip: 'Drag file here or click to upload',
    leadSession: 'Lead Session',
    gameSession: 'Game Session',
    endSession: 'End Session',
  },
  optionalGroupItem: {
    alert: 'Configuration error',
    customInput: {
      placeholder: '-',
    },
    validate: {
      warning: 'Integer Only',
      warning1: 'Number of characters has exceeded the maximum',
      warning2: 'Must be greater than 0',
      warning3: 'Please enter a valid positive integer',
    },
  },
  updateResourceInZipButton: {
    text: 'Update',
    error: 'Extra Variables parsing error',
  },
  templateMixin: {
    error: 'Configuration content under the current category validate fail',
  },
  localResourceInZipDialog: {
    title: 'Update',
    tips: 'Upload Only',
    rules: 'Width & Height Restriction',
    imageUploader: {
      error: 'Failed to read file',
    },
  },
  store: {
    error: 'Failed to find the asset',
    error1: 'JSON Parsing Error',
    error2: 'Please complete the label configuration of the material',
  },
  categoryConfig: {
    visible: 'Show',
    hidden: 'Hide',
    volume: 'Volume',
    cloud: 'Select from the cloud',
    reset: 'Reset',
    clear: 'Clear',
    linkage: 'The part where the same asset exists will be modified:',
  },
  readMode: 'Read Mode',
  selectFinish:
    'After completing the selection, proceed to adjust specific resources and gameplay within the scene.',
}
